import { render, staticRenderFns } from "./IconKeySolid.vue?vue&type=template&id=10eb0800"
import script from "./IconKeySolid.vue?vue&type=script&lang=js"
export * from "./IconKeySolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports